/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-cd-round-radio-button',
  templateUrl: './cd-round-radio-button.component.html',
  styleUrls: ['./cd-round-radio-button.component.scss'],
  imports: [NgClass],
})
export class CdRoundRadioButtonComponent implements OnInit {
  @Input() options: { label: string; value: any }[] = [];
  @Input() selectedValue?: any;
  @Output() selectedValueChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  onChange(value: any) {
    this.selectedValue = value;
    this.selectedValueChange.emit(this.selectedValue);
  }
}
